import { Button, Group } from '@mantine/core';

/**
 * Up and down, as buttons.
 *
 * Reordering has to work from the keyboard, and a drag handle on its own does not: a handle is a
 * pointer gesture with nothing behind it for somebody on a keyboard or a screen reader. Two plain
 * buttons are the whole feature, they tab like anything else, and each says which row it moves.
 */
export function MoveButtons({
  what,
  index,
  total,
  onMove,
}: {
  /** Named in the button labels, for example "question 2". */
  what: string;
  index: number;
  total: number;
  onMove: (index: number, delta: number) => void;
}) {
  if (total < 2) return null;
  return (
    <Group gap={4} wrap="nowrap">
      <Button
        variant="subtle"
        color="gray"
        size="compact-sm"
        onClick={() => onMove(index, -1)}
        disabled={index === 0}
        aria-label={`Move ${what} up`}
      >
        Move up
      </Button>
      <Button
        variant="subtle"
        color="gray"
        size="compact-sm"
        onClick={() => onMove(index, 1)}
        disabled={index === total - 1}
        aria-label={`Move ${what} down`}
      >
        Move down
      </Button>
    </Group>
  );
}
